var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"border-around"},[_c('vs-row',[_c('EmailEditor',{ref:"formEditor",attrs:{"displayMode":"web","min-height":"800px","options":_vm.options,"tools":_vm.tools,"projectId":_vm.projectId},on:{"load":_vm.editorLoaded,"ready":_vm.editorReady}})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }